export const checkHasSpecialExceptionStatus = (
  specialExceptionStatusId: string | undefined
) => {
  return !!specialExceptionStatusId && specialExceptionStatusId !== '0';
};
